import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: ['box', 'boxActivitiesLength'],
})
export default class AboutGiftComponent extends Vue {
  tabToShow = 'FirstTab';
  tabToToggle = '';
  expanded = false;

  innerTab = [
    { icon: 'Gift2', text: 'para elegir', name: 'FirstTab' },
    { icon: 'shuffle', text: 'Cambio instantáneo', name: 'SecondTab' },
    {
      icon: 'boxperspective',
      text: 'Regalo digital o físico',
      name: 'ThirdTab',
    },
  ];

  beforeMount() {
    if (!this.box.is_physical) {
      this.innerTab[2] = {
        icon: 'LaptopPerspective',
        text: 'Regalo digital',
        name: 'ThirdTab',
      };
    }
  }

  get isPhysical() {
    return this.box.is_physical;
  }

  changeTabToShow(name) {
    this.tabToShow = name;
  }

  toggleMobileTab(refName) {
    if (this.tabToToggle === refName) {
      this.expanded = !this.expanded;
    } else {
      if (this.tabToToggle !== '') {
        this.expanded = false;
      }
      this.tabToToggle = refName;
      this.expanded = !this.expanded;
    }
  }
}
